(function() {
  'use strict';
  
  let isInitialized = false;
  
  function initCategoryMenu() {
    if (isInitialized) return;
    
    // 等待DOM完全加载
    const categoryItems = document.querySelectorAll('.menu-left li');
    const menuPanels = document.querySelectorAll('.menu-right-content');
    
    if (categoryItems.length === 0) {
      // 如果元素还没加载，延迟重试
      setTimeout(initCategoryMenu, 100);
      return;
    }
    
    isInitialized = true;
    
    // 确保第一个分类在页面加载时是激活状态
    if (categoryItems.length > 0) {
      categoryItems.forEach(cat => cat.classList.remove('active'));
      menuPanels.forEach(panel => {
        panel.classList.add('dis-hide-none');
        panel.classList.remove('dis-show');
      });
      
      categoryItems[0].classList.add('active');
      const firstPanel = document.getElementById('menu-right-content-1');
      if (firstPanel) {
        firstPanel.classList.remove('dis-hide-none');
        firstPanel.classList.add('dis-show');
      }
    }
    
    // 分类切换功能 - 使用鼠标悬停
    categoryItems.forEach(item => {
      item.addEventListener('mouseenter', function() {
        const categoryId = this.dataset.id;
        
        // 移除所有active类
        categoryItems.forEach(cat => cat.classList.remove('active'));
        menuPanels.forEach(panel => {
          panel.classList.add('dis-hide-none');
          panel.classList.remove('dis-show');
        });
        
        // 添加active类到当前悬停的项目
        this.classList.add('active');
        
        // 显示对应的内容面板
        const targetPanel = document.getElementById(`menu-right-content-${categoryId}`);
        if (targetPanel) {
          targetPanel.classList.remove('dis-hide-none');
          targetPanel.classList.add('dis-show');
        }
      });
      
      // 保持点击链接功能
      item.addEventListener('click', function(e) {
        // 如果点击的是链接，允许正常跳转
        const link = this.querySelector('a');
        if (link && e.target.tagName === 'A') {
          return true;
        } else {
          e.preventDefault();
        }
      });
    });
    
    // 添加菜单项悬停效果
    const menuItems = document.querySelectorAll('.t4s-type__category_split');
    menuItems.forEach(menuItem => {
      menuItem.addEventListener('mouseenter', function() {
        this.classList.add('is--hover');
      });
      
      menuItem.addEventListener('mouseleave', function() {
        this.classList.remove('is--hover');
      });
    });
  }
  
  // 多种初始化方式确保兼容性
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCategoryMenu);
  } else {
    initCategoryMenu();
  }
  
  // 页面完全加载后再次检查
  window.addEventListener('load', function() {
    setTimeout(initCategoryMenu, 50);
  });
  
  // 如果使用了Turbo或其他页面加载库，也监听这些事件
  document.addEventListener('shopify:section:load', initCategoryMenu);
  document.addEventListener('shopify:section:reorder', initCategoryMenu);
  
})();

// 商品sku选择
(function () {
  document.addEventListener("DOMContentLoaded", function () {

  document.addEventListener('click', function(e) {
    const link = e.target.closest('.menu-left a');
    if (link) {
      e.stopPropagation();
      e.preventDefault();
      window.location.href = link.href;
    }
  });





    let currentBundleId = null;       // 当前选中的 bundle 子变体 id（如果有）
    let currentMainVariant = null;    // 当前的主变体（option1）
    let previousMainVariant = null;   // 用于检测主变体是否变化

    // 处理 Power 变体选择的点击事件
document.querySelectorAll('.t4s-swatch__item').forEach(item => {
  item.addEventListener('click', function () {
    // 获取选中的 Power 值
    const powerValue = this.getAttribute('data-value');
    
    // 更新页面上显示的 Power 值
    const currentValueElement = this.closest('.t4s-swatch__option').querySelector('.t4s-swatch__current');
    if (currentValueElement) {
      currentValueElement.textContent = powerValue;
    }

    // 更新 currentMainVariant 或 currentBundleId
    currentMainVariant = powerValue.toLowerCase(); // 假设这里 Power 作为主变体
    updateAllBundleVariants(); // 更新所有 bundle 变体的显示
  });
});


    // helper：设置页面上显示的当前值（data-current-value）
    function setCurrentValueText(value) {
      const curEl = document.querySelector('[data-current-value-1]');
      if (!curEl) return;
      // 传入空值时，使用 data-default-value 回退，否则使用传入值
      curEl.textContent = (value === null || typeof value === 'undefined' || value === '') 
        ? (curEl.dataset.defaultValue || curEl.textContent) 
        : value;
    }

    // helper：清除所有子变体的选中状态（用于主变体变化时重置）
    function clearBundleSelection() {
      currentBundleId = null;
      document.querySelectorAll(".bundle-variant-wrapper .variant-container").forEach(el => el.classList.remove("show"));
      document.querySelectorAll(".bundle-variant-wrapper .variant-item").forEach(el => el.classList.remove("active"));
      document.querySelectorAll(".bundle-variant-wrapper .variant-replenish").forEach(el => el.classList.remove("expanded"));
      // 把显示文字重置为默认
      setCurrentValueText(null);
    }

    // 更新所有 bundle 的显示（根据 currentMainVariant / currentBundleId）
function updateAllBundleVariants() {
  const allGroups = document.querySelectorAll(".bundle-group");

  allGroups.forEach(group => {
    const groupVariant = group.dataset.mainVariant?.toLowerCase();
    if (!currentMainVariant) {
      group.style.display = "block";
      return;
    }
    const match = groupVariant === currentMainVariant.toLowerCase();
    group.style.display = match ? "block" : "none";
  });

  const bundleWrappers = document.querySelectorAll(".bundle-variant-wrapper");
  bundleWrappers.forEach(wrapper => {
    const variantContainer = wrapper.querySelector(".variant-container");
    const variantItem = wrapper.querySelector(".variant-item");
    const variantReplenish = wrapper.querySelector(".variant-replenish");

    if (!variantContainer || !variantItem) return;

    const wrapperVariantId = variantContainer.dataset.variantId ? parseInt(variantContainer.dataset.variantId, 10) : null;
    const belongsToCurrentMain =
      !wrapper.dataset.mainVariant ||
      wrapper.dataset.mainVariant.toLowerCase() === currentMainVariant?.toLowerCase();

    wrapper.style.display = belongsToCurrentMain ? "" : "none";

    // 高亮：当 wrapperVariantId 等于 currentBundleId 时显示
    if (currentBundleId && wrapperVariantId === parseInt(currentBundleId, 10)) {
      variantContainer.classList.add("show");
      variantItem.classList.add("active");
      if (variantReplenish) {
        variantReplenish.classList.add("expanded");
        variantReplenish.style.maxHeight = (variantReplenish.scrollHeight + 20) + "px";
      }
    } else {
      variantContainer.classList.remove("show");
      variantItem.classList.remove("active");
      if (variantReplenish) {
        variantReplenish.classList.remove("expanded");
        variantReplenish.style.maxHeight = "0px";
      }
    }

    // 更新 UI（保证页面元素和 data-* 一致）
    const titleEl = wrapper.querySelector(".bottom_bar_title_target");
    const priceBox = wrapper.querySelector(".variant-price-box");
    const imgEl = wrapper.querySelector("img");
    const containsBox = wrapper.querySelector(".variant-replenish .metafield-rich_text_field");

    if (variantItem.dataset.title && titleEl) titleEl.textContent = variantItem.dataset.title;
    if (variantItem.dataset.price && priceBox) priceBox.innerHTML = variantItem.dataset.price;
    if (variantItem.dataset.imgsrc && imgEl) imgEl.src = variantItem.dataset.imgsrc;
    if (containsBox && variantItem.dataset.containsHtml) containsBox.innerHTML = variantItem.dataset.containsHtml;
  });
}


    // 查找最近父元素（兼容旧浏览器）
    function findClosest(element, selector) {
      if (!element) return null;
      if (element.closest) return element.closest(selector);
      let current = element;
      while (current && current.nodeType === 1) {
        if (
          (current.matches && current.matches(selector)) ||
          (current.msMatchesSelector && current.msMatchesSelector(selector))
        ) return current;
        current = current.parentElement;
      }
      return null;
    }

    // 点击 bundle 子项（选择某个子变体）
function handleBundleVariantClick(e) {
  // e 可能是一个真实事件或我们构造的对象，尽量支持两种
  const target = e.currentTarget || e.target || e;
  if (!target || typeof target.getAttribute !== "function") return;

  const wrapper = findClosest(target, ".bundle-variant-wrapper");
  const variantId = target.getAttribute("data-variant-id") || wrapper?.querySelector(".variant-item")?.getAttribute("data-variant-id");
  if (!variantId || !wrapper) return;

  // 更新当前选中的变体 ID
  currentBundleId = variantId;

  // 清除其他项的状态
  document.querySelectorAll(".bundle-variant-wrapper .variant-container").forEach(el => el.classList.remove("show"));
  document.querySelectorAll(".bundle-variant-wrapper .variant-item").forEach(el => el.classList.remove("active"));
  document.querySelectorAll(".bundle-variant-wrapper .variant-replenish").forEach(el => el.classList.remove("expanded"));

  const variantContainer = wrapper.querySelector(".variant-container");
  const variantItem = wrapper.querySelector(".variant-item");
  const variantReplenish = wrapper.querySelector(".variant-replenish");

  if (variantContainer) variantContainer.classList.add("show");
  if (variantItem) variantItem.classList.add("active");
  if (variantReplenish) variantReplenish.classList.add("expanded");

  // 更新页面上的 select（如果存在）
  const select = document.querySelector('select[name="id"]');
  if (select) {
    select.value = variantId;
    select.dispatchEvent(new Event("change", { bubbles: true }));
  }

  // 如果存在你的 swatch 控制器（你原来写的），也调用它
  if (window.T4NT && window.T4NT.swatch) {
    try { window.T4NT.swatch.changeVariant(variantId); } catch (err) { /* ignore */ }
  }

  // 更新页面显示的“当前选中”文本（优先 data-value，再 title）
  const showValue = variantItem?.dataset.value || variantItem?.dataset.title || "";
  setCurrentValueText(showValue);

  // 更新所有 bundle 变体显示
  updateAllBundleVariants();
}



    // 初始化：根据当前页面 select 的值去设置初始状态
    function initBundleVariants() {
      const select = document.querySelector('select[name="id"]');
      if (select && select.value) {
        // 当前选中的 variant id（可能是主变体下的某一子变体）
        currentBundleId = select.value;

        // 尝试优先读取 option 上的 data-main-variant；否则从 option 文本中解析
        const selectedOption = select.options[select.selectedIndex];
        currentMainVariant =
          (selectedOption && selectedOption.dataset && selectedOption.dataset.mainVariant) ||
          (selectedOption && (selectedOption.textContent.split("/")[0] || "").trim().toLowerCase()) ||
          document.querySelector(".bundle-group")?.dataset.mainVariant ||
          null;

        previousMainVariant = currentMainVariant;

        // 如果页面上有对应的子变体元素，更新“当前选中”显示
        const selectedVariantItem = document.querySelector(`.bundle-variant-wrapper .variant-item[data-variant-id="${select.value}"]`);
        if (selectedVariantItem) {
          setCurrentValueText(selectedVariantItem.dataset.value || selectedVariantItem.dataset.title || null);
        } else {
          // 没有匹配子变体 -> 使用默认提示
          setCurrentValueText(null);
        }

        updateAllBundleVariants();
      } else {
        // 没有 select（或无选中值） -> 显示默认提示并显示所有 group
        setCurrentValueText(null);
        updateAllBundleVariants();
      }
    }

    // 监听主产品选择器的变化（外部选择器会触发）
    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect) {
      variantSelect.addEventListener("change", function (e) {
        const newVariantId = e.target.value;
        const selectedOption = e.target.options[e.target.selectedIndex];

        const newMain = 
          selectedOption?.dataset?.mainVariant?.toLowerCase() ??
          currentMainVariant;

        // 如果主变体实际发生了变化 -> 清除所有子变体选择
        if (previousMainVariant && newMain && previousMainVariant.toLowerCase() !== newMain.toLowerCase()) {
          clearBundleSelection();
        }

        // 更新当前主变体追踪
        previousMainVariant = newMain;
        currentMainVariant = newMain;

        // 即使没有清除（比如只是同主变体内切换），也更新所有 wrapper 的可视性
        updateAllBundleVariants();
      });
    }

    // 全局点击代理：点击到子变体的 .variant-container 时触发选择
    document.addEventListener("click", function (e) {
      const clickedContainer = findClosest(e.target, ".bundle-variant-wrapper .variant-container");
      if (clickedContainer) {
        // 把 clickedContainer 作为 currentTarget 传入，兼容你的原先处理逻辑
        handleBundleVariantClick({
          preventDefault: e.preventDefault.bind(e),
          stopPropagation: e.stopPropagation.bind(e),
          currentTarget: clickedContainer,
          target: clickedContainer
        });
      }
    });

    // 页面加载时初始化
    initBundleVariants();
    // window load 再确保一次（你原来写了）
    window.addEventListener("load", initBundleVariants);


    // 兼容快速预览
    document.addEventListener("t_ajax_qv_completed", function () {
      console.log("🔵 Quick View 内容加载完成，准备执行 initBundleVariants()");
      if (typeof initBundleVariants === "function") {
        initBundleVariants();
      } else {
        console.warn("❌ initBundleVariants 不存在");
      }
    });


  });

})();


(function (){

// buy now按钮
document.addEventListener("DOMContentLoaded", function () {

  function bindBuyNow() {
    var btn = document.getElementById("kalles-buy-now");
    if (!btn) return;

    if (btn.dataset.bound === "true") return;
    btn.dataset.bound = "true";

    btn.addEventListener("click", function (e) {
      e.preventDefault();

      // 获取当前变体
      // var variantIdEl = document.querySelector('form[action="/cart/add"] [name="id"]');
      var variantIdEl = document.querySelector('form[action$="/cart/add"] [name="id"]');
      if (!variantIdEl) {
        alert("Please select a variant.");
        return;
      }
      var variantId = variantIdEl.value;

      // 获取数量
      var qtyInput = document.querySelector('.t4s-qty__input');
      var qty = qtyInput ? Number(qtyInput.value) : 1;

      // ⭐ 核心代码：通过 cart permalink 创建购物车并立即跳 checkout
      var checkoutUrl = `/cart/${variantId}:${qty}?return_to=/checkout`;

      console.log("Checkout URL:", checkoutUrl);

      window.location.href = checkoutUrl;
    });

    console.log("Buy Now 按钮绑定完成");
  }

  // 使用 MutationObserver 捕捉 Kalles sticky bar 动态加载
  const observer = new MutationObserver(bindBuyNow);
  observer.observe(document.body, { childList: true, subtree: true });

  bindBuyNow();
});

})();


// 加入购物车价格详情
function toggleCheckoutSummary() {
  const summary = document.querySelector('.checkout-cart-summary');
  const btn = document.querySelector('.summary-toggle-btn');
  const icon = btn.querySelector('.arrow-icon');

  if (!summary) return;

  const isExpanded = summary.classList.contains('expanded');

  if (isExpanded) {
    summary.classList.remove('expanded');
    summary.style.maxHeight = '0px';
    icon.style.transform = 'rotate(0deg)'; // ▼
  } else {
    summary.classList.add('expanded');
    summary.style.maxHeight = summary.scrollHeight + 'px';
    icon.style.transform = 'rotate(180deg)'; // ▲
  }
}

